import '../index.css';

import logo from '../assets/logo.png';
export default function Loader() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center px-4">
      <img src={logo} />
    </div>
  );
}
